module.exports = __webpack_public_path__ + "6e435461.svg";